import type { TElement } from '@udecode/plate-common';

export const getTableColumnCount = (tableNode: TElement) => {
  return Math.max(...(tableNode.children as TElement[]).map((row) => {
    const { children: cols } = row;
    return cols.reduce((acc, col) => {
      const colSpan = typeof col.colSpan === 'number' ? col.colSpan : 1;
      return acc + colSpan;
    }, 0);
  }));
};
